// eslint-disable
import { GET_USER_PROFILE_DATA, GET_USER_LIST_MINIMAL_DATA } from '../../../actions'

export const getUserProfileDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USER_PROFILE_DATA:
      return { ...state, ...action.payload }

    default:
      return state
  }
}

export const getUserListMinimalDataReducer = (state = [], action) => {
  switch (action.type) {
    case GET_USER_LIST_MINIMAL_DATA:
      return [...action.payload]

    default:
      return state
  }
}
